import { render, staticRenderFns } from "./BusinessNameAmendmentEscalationFile.vue?vue&type=template&id=3586bb62&scoped=true&"
import script from "./BusinessNameAmendmentEscalationFile.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAmendmentEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAmendmentEscalationFile.vue?vue&type=style&index=0&id=3586bb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586bb62",
  null
  
)

export default component.exports